import { render } from "./SwiperComp.vue?vue&type=template&id=64768678&scoped=true"
import script from "./SwiperComp.vue?vue&type=script&lang=js"
export * from "./SwiperComp.vue?vue&type=script&lang=js"

import "./SwiperComp.vue?vue&type=style&index=0&id=64768678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64768678"]])

export default __exports__